import { Divider, makeStyles } from "@material-ui/core";
import React from "react";
import { Link } from "react-router-dom";
import { SecurityIcon, SpeedIcon, TrustWorthy } from "v2/icons";
const useStyles = makeStyles(() => ({
  root: {
    background: "rgba(196, 196, 196, 0.81)",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  top: {
    marginLeft: "auto",
    marginRight: "auto",
    display: "flex",
    justifyContent: "space-evenly",
    padding: 16,
    width: "100%",
    "@media only screen and (max-width: 1280px)": {
      flexDirection: "column",
    },
  },
  element: {
    display: "flex",
    flexDirection: "column",
    padding: 16,
    margin: 16,
    flex: 1,
    width: "100%",
    justifyContent: "center",
    "@media only screen and (max-width: 1280px)": {
      marginRight: "auto",
      marginLeft: "auto",
    },
  },
  title: {
    fontWeight: 800,
    marginLeft: "auto",
    marginRight: "auto",
  },
  text: {
    textAlign: "center",
    fontSize: 12,
    fontWeight: 400,
  },
  activeContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    textAlign: "center",
    marginTop: "auto",
    marginBottom: "auto",
    "&>div": {
      fontWeight: 700,
      display: "block",
      paddingBottom: 16,
      textJustify: "center",
    },
  },
  secrutyContent: {
    display: "flex",
    justifyContent: "center",
    marginLeft: "auto",
    marginRight: "auto",
  },
  inline: {
    display: "flex",
    marginLeft: 40,
    marginRight: "auto",
    padding: 16,
    "@media only screen and (max-width: 1280px)": {
      marginLeft: "auto",
      marginRight: "auto",
    },
    "@media only screen and (max-width: 780px)": {
      flexDirection: "column",
    },
    "&>div": {
      marginTop: "auto",
      marginBottom: "auto",
      marginLeft: 10,
      fontWeight: 700,
      "@media only screen and (max-width: 1280px)": {
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
      },
    },
  },
  nav: {
    display: "flex",
    marginLeft: "auto",
    marginRight: "auto",
    paddingTop: 16,
    justifyContent:"center",
    "@media only screen and (max-width: 1280px)": {
      width: "100%",
      flexDirection: "flex",
      marginLeft: "auto",
      marginRight: "auto",
    },
  },
  ul: {
    listStyleType: "none",
    fontWeight: 700,
    marginLeft: "auto",
    marginRight: "auto",
    textAlign: "center",
    "@media only screen and (max-width: 1280px)": {
      display: "flex",
      width: "100%",
      flexDirection: "flex",
      marginLeft: "auto",
      marginRight: "auto",
    },
    "&>li": {
      float: "left",
      display: "inline",
      marginLeft: "auto",
      marginRight: "auto",
      "&>a": {
        display: "block",
        color: "#363636",
        textAlign: "center",
        padding: 16,
        marginLeft: 5,
        marginRight: 5,
        "@media only screen and (max-width: 1280px)": {
          display: "flex",
          width: "100%",
          flexDirection: "flex",
          marginLeft: "auto",
          marginRight: "auto",
        },
        textDecoration: "none",
        position: "relative",
        "&:hover": {
          color: "#DDBB78",
          textDecoration: "underline",
        },
      },
    },
  },
  social_footer_ul: {
    display: "table",
    margin: "15px auto 0 auto",
    "@media only screen and (max-width: 1280px)": {
      display: "flex",
      marginRight: "auto",
      marginLeft: "auto",
      justifyContent: "center",
    },
    listStyleType: "none",
    "&>li": {
      paddingLeft: 20,
      paddingTop: 10,
      "@media only screen and (max-width: 1280px)": {
        display: "flex",
        marginRight: "auto",
        marginLeft: "auto",
        justifyContent: "center",
      },
      float: "left",
      "&>i": { width: 20, height: 20, textAlign: "center" },
    },
  },
}));
export function Footer() {
  const styles = useStyles();
  return (
    <footer className={styles.root}>
      <div className={styles.top}>
        <div className={styles.element}>
          <div className={styles.secrutyContent}>
            <div className={styles.inline}>
              <div>
                <TrustWorthy />
              </div>
              <div>Fiable</div>
            </div>
            <div className={styles.inline}>
              <div>
                <SpeedIcon />
              </div>
              <div>Rapide</div>
            </div>
            <div className={styles.inline}>
              <div>
                <SecurityIcon />
              </div>
              <div>Sécurité</div>
            </div>
          </div>
          <Divider variant="middle" />
          <div className={styles.nav}>
            <ul className={styles.ul}>
              <li>
                <Link
                  activeStyle={{
                    color: "#DDBB78",
                    textDecoration: "underline",
                  }}
                  to="/"
                >
                  Accueil
                </Link>
              </li>
              <li>
                <Link
                  activeStyle={{
                    color: "#DDBB78",
                    textDecoration: "underline",
                  }}
                  to="about"
                >
                  A propos
                </Link>
              </li>
              <li>
                <Link
                  activeStyle={{
                    color: "#DDBB78",
                    textDecoration: "underline",
                  }}
                  to="contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div className={styles.nav}>
            Copyright @2021 |
            <b style={{ marginLeft: 5 }}> TRAX-CORPORATION</b>
          </div>
        </div>
      </div>
    </footer>
  );
}
